module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-room-2.b7ea190e.jpg";